import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendCallerSubscriptionReceipt = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation SendCallerSubscriptionReceipt($phoneNumber: String!) {
        sendCallerSubscriptionReceipt(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.sendCallerSubscriptionReceipt ?? false;
};
